import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import { FinancingRequestsDocument, type FinancingRequestsQuery } from 'graphql/generated/graphql';
import type { TListItem } from 'graphql/types';

/** The requests of a page (the schema allows a null list and null items). */
export type TFinancingRequests = NonNullable<
  FinancingRequestsQuery['financingRequests']
>['requests'];

export type TFinancingRequest = TListItem<TFinancingRequests>;

const useGetFinancingRequests = ({
  currentPage,
  filter,
}: {
  currentPage: number;
  filter: string;
}) => {
  const { data, loading } = useQuery(FinancingRequestsDocument, {
    variables: {
      filter,
      offset: COUNT_TABLE_RECORDS * (currentPage - 1),
      limit: COUNT_TABLE_RECORDS,
    },
  });

  const financingRequests = useMemo(() => {
    const noRequests: TFinancingRequests = [];
    return get(data, 'financingRequests.requests', noRequests);
  }, [data]);
  const total = get(data, 'financingRequests.count', 0);

  return { financingRequests, total, loading };
};

export default useGetFinancingRequests;
